<template>
  <div id="login_page" class="login-page">
    <div class="login-logo">
      <img src="../../assets/images/hbut_logo.png" alt="" />
    </div>
    <div class="login-container" id="login_box" v-loading="loading">
      <!-- <el-tooltip
        class="item"
        effect="dark"
        :content="isScan ? '账号登录' : '扫码登录'"
        placement="left"
      >
        <div
          class="contr-icon"
          :class="{ 'pc-icon': isScan, 'code-icon': !isScan }"
          @click="handleExchange"
        ></div>
      </el-tooltip> -->

      <div class="login-title">{{ isScan ? "扫码登录" : "账号登录" }}</div>
      <div class="login-content">
        <el-form
          :model="data"
          :rules="rules"
          ref="data"
          label-position="left"
          v-show="!isScan"
        >
          <el-form-item prop="username">
            <el-input
              v-model="data.username"
              type="text"
              placeholder="请输入用户名"
              @keyup.enter.native="submitForm()"
            >
              <template slot="prefix">
                <img src="../../assets/images/icon_user.png" alt="" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="data.password"
              type="password"
              placeholder="请输入密码"
              show-password
              @keyup.enter.native="submitForm()"
            >
              <template slot="prefix">
                <img src="../../assets/images/icon_pwd.png" alt="" /> </template
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            :disabled="isSubmit"
            class="btn btn-success btn-block"
            @click="submitForm()"
            >登录</el-button
          >
          <div style="padding-top: 10px;color: red;font-size: 16px;">
            <span>系统提示：登录用户名为考生号/身份证号，密码为身份证号后八位。</span>
          </div>
        </el-form>
        <!-- 扫码登录--welink二维码容器 -->
        <div class="qrcode-container" id="login_container" v-if="isScan"></div>
      </div>
      <div v-if="sysMsg" class="err-msg">{{ sysMsg }}</div>
    </div>
    <div class="login-page-footer">
      Copyright© {{ new Date().getFullYear() }} 武汉智丽丰信息科技有限公司
    </div>
  </div>
</template>

<script>
import { hex_sha1 } from "@/libs/sha1.js";
import { mapState } from "vuex";
export default {
  name: "index",
  data() {
    return {
      isSubmit: false,
      data: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "change",
          },
        ],
      },
      sysMsg: "",
      isScan: false, // 是否扫码登录
      loading: false,
      redirectUri: window.location.origin + window.location.pathname,
      enrollmentYear: ""
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "corpId", "agentId", "_APP_KEY", "_CURRENT_YEAR2"]),
  },
  created() {
    let params = this.getParams(window.location.search); // 链接携带参数
    // 获取code后跳转至系统登录并携带code参数
    if (params.code) {
      let url = window.location.href.replace(window.location.search, "");
      history.pushState({ url: url }, "", url);
      this.qyWxLogin(params.code);
    }
    if (params.ticket) {
      // alert('免登中'+params.ticket)
      let url = window.location.href.replace(window.location.search, "");
      history.pushState({ url: url }, "", url);
      this.idaasLogin(params.ticket);
    }
    if (params.portal) {
      let portal = params.portal.split("_");
      let platform = portal[0];
      let token = portal[1];
      let url = window.location.href.replace(window.location.search, "");
      history.pushState({ url: url }, "", url);
      this.loginByToken(platform, token);
    }
  },
  mounted() {
    this.getEnrollmentYear();
    // 优先展示扫码登录方式
    this.getQrcode();
  },
  methods: {
    //获取入学年份
    getEnrollmentYear() {
      this.$http.get("/account/sys/dict/listByType?type=currentYear").then((res) => {
        console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          this.enrollmentYear = res.data[0].dictValue;
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    // idaas免登
    idaasLogin(ticket) {
      this.isSubmit = true;
      this.$http
        .post("/account/sys/user/idaas/login", {
          ticket: ticket,
          platform: this._APP_KEY,
          appKey: this._APP_KEY,
        })
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            let roleId = res.data.roleId;
            let userRoleList = res.data.userRoleList;
            // 如果是非学生角色，则展示角色名
            let roleName = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleName
              : "";
            let roleFlag = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleFlag
              : "";
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("roleId", roleId ? roleId : "");
            localStorage.setItem("roleName", roleName);
            localStorage.setItem("roleFlag", roleFlag);
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            let category = res.data.category;
            if (category === "student") {
              if(res.data.enrollmentYear != this.enrollmentYear ){
                console.log("this.enrollmentYear",this.enrollmentYear);
                this.$message.error(`非系统本年新生，如需进入系统请联系辅导员！`);
              }else{
                this.$router.replace("/home");
              }
            } else {
              this.$router.replace("/home");
            }
          } else {
            this.$message.error(`登录失败，${res.msg}`);
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error(`登录失败，${err.msg}`);
          this.isSubmit = false;
        });
    },
    // 企业微信扫码登录
    qyWxLogin(code) {
      this.isSubmit = true;
      this.$http
        .get("/account/sys/user/wecom/login", {
          params: { code: code, platform: this._APP_KEY, state: this._APP_KEY },
        })
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            let roleId = res.data.roleId;
            let userRoleList = res.data.userRoleList;
            // 如果是非学生角色，则展示角色名
            let roleName = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleName
              : "";
            let roleFlag = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleFlag
              : "";
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("roleId", roleId ? roleId : "");
            localStorage.setItem("roleName", roleName);
            localStorage.setItem("roleFlag", roleFlag);
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            let category = res.data.category;
            if (category === "student") {
              this.$router.replace("/home");
            } else {
              this.$router.replace("/home");
            }
          } else {
            this.$message.error(`登录失败，${res.msg}`);
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error(`登录失败，${err.msg}`);
          this.isSubmit = false;
        });
    },
    // 账号登录、二维码登录方式切换
    handleExchange() {
      this.isScan = !this.isScan;
      if (this.isScan) {
        this.$nextTick(() => {
          this.getQrcode();
        });
      }
    },
    // 获取企业微信扫码登录二维码
    getQrcode() {
      let url = this.redirectUri;
      console.log(url);
      let corpId = this.corpId;
      let agentId = this.agentId;
      new WwLogin({
        // eslint-disable-line
        id: "login_container",
        appid: corpId,
        agentid: agentId,
        redirect_uri: encodeURI(url),
        state: "eiere8458565df43gggfag4g35",
        href:
          "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogYmxvY2s7fQ0KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDt9DQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmUgICFpbXBvcnRhbnR9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fSA=",
        // href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMDBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30g",
        lang: "zh",
      });
    },
    // 账号密码登录
    goLogin() {
      let params = {
        username: this.data.username,
        password: hex_sha1(this.data.password),
      };
      this.isSubmit = true;
      this.loading = true;
      this.$http
        .post("/account/sys/user/login", params, {
          params: { platform: this._APP_KEY },
        })
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            let roleId = res.data.roleId;
            let userRoleList = res.data.userRoleList;
            // 如果是非学生角色，则展示角色名
            let roleName = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleName
              : "";
            let roleFlag = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleFlag
              : "";
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("roleId", roleId ? roleId : "");
            localStorage.setItem("roleName", roleName);
            localStorage.setItem("roleFlag", roleFlag);
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            let category = res.data.category;
            if (category === "student") {
              if(res.data.enrollmentYear != this.enrollmentYear ){
                console.log("this.enrollmentYear",this.enrollmentYear);
                this.$message.error(`非系统本年新生，如需进入系统请联系辅导员！`);
              }else {
                this.$router.replace("/home");
              }
            } else {
              this.$router.replace("/home");
            }
          } else {
            this.$message.error(`登录失败，${res.msg}`);
          }
          this.isSubmit = false;
          this.loading = false;
        })
        .catch((err) => {
          // this.$message.error(`登录失败，${err}`);
          // this.$message.warning('请求超时，请稍后重试！')
          this.isSubmit = false;
          this.loading = false;
        });
    },
    // 提交登录表单--登录
    submitForm() {
      this.$refs["data"].validate((valid) => {
        if (valid) {
          this.goLogin();
        } else {
          return false;
        }
      });
    },
    // 获取window.location.search参数
    getParams(search) {
      let params = {};
      let reg = /[?&][^?&]+=[^?&]+/g;
      let array = search.match(reg);
      if (array) {
        array.forEach((item) => {
          let itemArray = item.split("=");
          if (itemArray && itemArray.length === 2) {
            params[
              decodeURIComponent(itemArray[0])
                .replace("?", "")
                .replace("&", "")
            ] = decodeURIComponent(itemArray[1]);
          }
        });
      }
      return params;
    },
    loginByToken(platform, token) {
      let params = { platform };
      this.$http
        .post("/account/sys/user/loginByToken", null, {
          params,
          headers: { token },
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            let roleId = res.data.roleId;
            let userRoleList = res.data.userRoleList;
            // 如果是非学生角色，则展示角色名
            let roleName = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleName
              : "";
            let roleFlag = roleId
              ? userRoleList.find((item) => item.roleId == roleId).roleFlag
              : "";
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("roleId", roleId ? roleId : "");
            localStorage.setItem("roleName", roleName);
            localStorage.setItem("roleFlag", roleFlag);
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            let category = res.data.category;
            if (category === "student") {
              this.$router.replace("/home");
            } else {
              this.$router.replace("/home");
            }
          } else {
            this.$message.error(`登录失败，${res.msg}`);
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error(`登录失败，${err}`);
          this.isSubmit = false;
        });
    },
  },
};
</script>
